import { useSearchParams } from 'react-router-dom';

import { TicketsRefinementKeysE } from 'declarations/enums/tickets';
import type { BannerMessageI } from 'declarations/interfaces/notifications';
import { useFetchBannerMessages } from 'hooks/api/useNotifications';

type UseBannerMessagesT = {
  bannerMessages: BannerMessageI[] | null;
  isLoadingBannerMessages: boolean;
  isFetchingBannerMessages: boolean;
  bannerMessageColor: (
    messageType: string | null
  ) =>
    | 'darkBlue'
    | 'darkPurple'
    | 'darkGreen'
    | 'black'
    | 'light'
    | 'lightGrey'
    | 'grey'
    | 'darkGrey'
    | 'dark'
    | 'purple'
    | 'yellow'
    | 'success'
    | 'warning'
    | 'error'
    | 'semiTransparent'
    | undefined;
};

const useBannerMessages = (): UseBannerMessagesT => {
  /**
   * Hooks
   */
  const [searchParams] = useSearchParams();
  const roofTopId = searchParams.get(TicketsRefinementKeysE.RoofTopId) || '';

  /**
   * Api hooks
   */
  const bannerMessagesResult = useFetchBannerMessages({ roofTopId: roofTopId });
  const bannerMessageColor = (
    messageType: string | null
  ):
    | 'darkBlue'
    | 'darkPurple'
    | 'darkGreen'
    | 'black'
    | 'light'
    | 'lightGrey'
    | 'grey'
    | 'darkGrey'
    | 'dark'
    | 'purple'
    | 'yellow'
    | 'success'
    | 'warning'
    | 'error'
    | 'semiTransparent'
    | undefined => {
    const defaultColor = 'darkBlue';

    if (messageType === 'Global') return 'darkPurple';
    else if (messageType === 'OemFamily' || messageType === 'Account') return 'darkGreen';
    else if (messageType === 'RoofTop') return defaultColor;

    return undefined; // Return undefined for unrecognized message types
  };

  return {
    bannerMessages: bannerMessagesResult.data ?? null,
    isLoadingBannerMessages: bannerMessagesResult.isLoading ?? false,
    isFetchingBannerMessages: bannerMessagesResult.isFetching ?? false,
    bannerMessageColor,
  };
};

export default useBannerMessages;
